import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FiInstagram } from "react-icons/fi";
import { getImageUrl } from "../services/api";
import "./Footer.css";

const Footer = () => {
  const [logoUrl, setLogoUrl] = useState("");

  useEffect(() => {
    setLogoUrl(getImageUrl("logo"));
  }, []);
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <img src={logoUrl} alt="Personal Regrets" className="footer-logo" />
            <p><i>Porte fièrement tes faiblesses</i></p>
            <div className="social-links">
              <a
                href="https://www.instagram.com/personal.regrets/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FiInstagram />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Boutique</h4>
            <ul>
              <li>
                <Link to="/shop">Tous les produits</Link>
              </li>
              <li>
                <Link to="/shop?featured=true">Nouveautés</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Informations</h4>
            <ul>
              <li>
                <Link to="/about">À propos</Link>
              </li>
              <li>
                <a href="mailto:personalregrets@gmail.com">Contact</a>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Légal</h4>
            <ul>
              <li>
                <Link to="/terms">Conditions générales</Link>
              </li>
              <li>
                <Link to="/privacy">Politique de confidentialité</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 Personal Regrets. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
